var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){!_vm.isViewMode && _vm.$emit('toggle-bookmark'),
      !_vm.isViewMode && (_vm.isImportant = !_vm.isImportant)}}},[(!_vm.isImportant)?_c('v-icon',{staticClass:"bookmark",style:({
      backgroundImage: ("url(" + (require('@/assets/img/bookmark-inactive.svg')) + ")"),
    }),attrs:{"title":"Пометить как важное"}}):_c('v-icon',{staticClass:"bookmark",style:({
      backgroundImage: ("url(" + (require('@/assets/img/bookmark.svg')) + ")"),
    }),attrs:{"title":"Пометить как обычное"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }